import React from "react";
import { usePermissions } from "react-admin";
import {
  Breadcrumb as BreadcrumbImpl,
  BreadcrumbItem as BreadcrumbItemImpl,
} from "@react-admin/ra-navigation";
import { filterByPermissions } from "../security/utils";
import { resources } from "../../app";

const Breadcrumb = () => {
  const { permissions } = usePermissions();

  const menuItems = filterByPermissions(resources, permissions).filter(
    (resource) => resource.isMenu
  );

  return (
    <BreadcrumbImpl>
      {menuItems.map((resource) => {
        return (
          <BreadcrumbItemImpl
            key={resource.name}
            name={resource.name}
            label={resource.title}
          >
            {resource.subMenu &&
              resource.subMenu
                .filter((resourceS) => resourceS.isMenu)
                .map((resourceS) => {
                  let list = [];

                  if (resourceS.create)
                    list.push(
                      <BreadcrumbItemImpl
                        name="create"
                        label="Добавяне"
                        key="add"
                      />
                    );

                  if (resourceS.edit)
                    list.push(
                      <BreadcrumbItemImpl
                        name="edit"
                        label="Редактиране"
                        key="edit"
                      />
                    );

                  if (list.length === 0) list = null;

                  return (
                    <BreadcrumbItemImpl
                      key={resourceS.name}
                      name={resourceS.name}
                      to={`${resource.name}.${resourceS.name}`}
                      label={resourceS.title}
                    >
                      {list}
                    </BreadcrumbItemImpl>
                  );
                })}
          </BreadcrumbItemImpl>
        );
      })}
    </BreadcrumbImpl>
  );
};

export default Breadcrumb;
